@if (data.length > 2) {
  <div>
    <div class="row">
      <div class="col-sm-2 text-right" >
        <mat-checkbox labelPosition="before" class="mat-mb-0 d-block" style="line-height: 40px" [(ngModel)]="checked" (click)="changeChecked()">{{label}}</mat-checkbox>
      </div>
      <div class="col-sm-10 animated fadeIn"  >
        <mat-select class="form-control" [disabled]="!checked" [(ngModel)]="myData.item" (ngModelChange)="updateMyData()" >
          @for (item of data; track item; let i = $index) {
            <mat-option [value]="item">{{ item.titre }} </mat-option>
          }
          <mat-option [value]="{'titre': 'autre' }">Autre</mat-option>
        </mat-select>
      </div>
    </div>
    @if (myData?.item?.titre === 'autre' && myData.checked) {
      <div class="row animated fadeIn" >
        <div class="col-sm-10 offset-2 mt-1">
          <input type="text" class="form-control" [(ngModel)]="autreChoix" placeholder="Autre choix"/>
        </div>
      </div>
    }
  </div>
}

